import RootScrollToTop from "./RootScrollToTop";
export default RootScrollToTop;
